import { Extension } from '@tiptap/core';
import { Plugin, PluginKey, TextSelection } from '@tiptap/pm/state';

/**
 * A press in the empty space under the document starts a paragraph there.
 *
 * Without it a document ending in a block is a dead end: no text position after the block means nothing
 * to put a caret in. Selecting the block and pressing Enter also works, but nobody finds that.
 */
export const ClickToAppend = Extension.create({
  name: 'clickToAppend',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        key: new PluginKey('clickToAppend'),
        props: {
          handleDOMEvents: {
            mousedown: (view, event) => {
              // Only the editor's own padding: a press on any child is that child's to handle.
              if (event.target !== view.dom || !view.editable) return false;
              const last = view.dom.lastElementChild;
              if (!last || event.clientY <= last.getBoundingClientRect().bottom) return false;

              const { doc, tr, schema } = view.state;
              const end = doc.content.size;
              // An empty paragraph already at the end is the caret's destination, not a reason for one more.
              if (!doc.lastChild?.isTextblock || doc.lastChild.content.size > 0) {
                tr.insert(end, schema.nodes.paragraph.create());
              }
              view.dispatch(tr.setSelection(TextSelection.near(tr.doc.resolve(tr.doc.content.size), -1)));
              view.focus();
              event.preventDefault();
              return true;
            },
          },
        },
      }),
    ];
  },
});
